import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionManagerService } from '../services/index';
import { GoogleAccessTokenService } from '../../features/user/auth/services/google-access-token.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleAccessTokenGuard implements CanActivate {
  public auth2: any;
  //
  constructor(
    private tokenService: GoogleAccessTokenService,
    private sessionManager: SessionManagerService,
  ) {}

  /**
   * Always allows navigation.
   *
   * This guard used to request a Google token and then block the route on a
   * poll that waited forever. On iPadOS the pop-up is blocked when there is no
   * user gesture, so the poll never resolved and the route never activated.
   * Now it just starts a renewal — silent where the platform allows it — and
   * lets the page load either way.
   */
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.tokenService
      .loadGISScript()
      .then(() => {
        this.tokenService.initializeAuth();
        this.tokenService.ensureFreshToken();
        return true;
      })
      .catch(() => {
        // A failed GIS load must not lock the user out of the route.
        return true;
      });
  }
}
